"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactDatepicker = _interopRequireDefault(require("react-datepicker"));
var _format = _interopRequireDefault(require("date-fns/format"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const DateInput = /*#__PURE__*/(0, _react.forwardRef)((_ref, ref) => {
  let {
    selectedDate,
    onDateChange,
    dateFormat,
    label,
    onBlur,
    minDate,
    maxDate,
    UI,
    controlError
  } = _ref;
  const allowedFormat = ['MM/dd/yyyy', 'MM/yyyy', 'QQQ, yyyy', 'yyyy']; // defining the allowed formats

  const [aDate, setADate] = (0, _react.useState)(selectedDate);
  const changeDate = date => {
    setADate(date);
    let outputDate = date;
    if (date) {
      outputDate = (0, _format.default)(date, dateFormat);
    }
    onDateChange(outputDate);
  };
  (0, _react.useEffect)(() => onDateChange(aDate), []);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "field has-addons"
  }, /*#__PURE__*/_react.default.createElement("label", {
    className: "label",
    htmlFor: "field"
  }, label, /*#__PURE__*/_react.default.createElement("div", {
    className: UI?.icon ? `control has-icons-${UI?.iconLocation} ` : 'control has-icons-right'
  }, /*#__PURE__*/_react.default.createElement(_reactDatepicker.default, {
    ref: ref,
    className: `input ${controlError}`,
    strictParsing: true,
    fixedHeight: true // fixed no of rows even if the days of months does not cover all rows
    ,
    selected: aDate,
    value: aDate,
    showMonthYearPicker: dateFormat && dateFormat.toLowerCase() === 'mm/yyyy' // activating month picker if format is month selector
    ,
    showQuarterYearPicker: dateFormat && dateFormat.toLowerCase() === 'qqq, yyyy' // activating quater picker if format is quater selector
    ,
    showYearPicker: dateFormat && dateFormat.toLowerCase() === 'yyyy' // activating year picker if format is quater selector
    ,
    onChange: date => changeDate(date) // change event association to callback
    ,
    onBlur: onBlur,
    minDate: minDate,
    maxDate: maxDate,
    dateFormat: allowedFormat.indexOf(dateFormat) > -1 ? dateFormat : 'MM/dd/yyyy' // verifying if given input is a valid format or not and reverting to default state
    ,
    placeholderText: dateFormat.toUpperCase(),
    portalId: "root-portal" // attaching the picker to and element of dom
    ,
    popperProps: {
      strategy: 'fixed'
    }
  }), UI?.icon ? /*#__PURE__*/_react.default.createElement("span", {
    className: UI?.iconLocation ? `icon is-${UI?.iconLocation}` : 'icon is-right'
  }, /*#__PURE__*/_react.default.createElement("i", {
    className: "material-icons"
  }, UI?.icon)) : /*#__PURE__*/_react.default.createElement("span", {
    className: "icon is-right"
  }, /*#__PURE__*/_react.default.createElement("i", {
    className: "material-icons"
  }, "calendar_month")))), allowedFormat.indexOf(dateFormat) === -1 && /*#__PURE__*/_react.default.createElement("div", {
    className: "help is-danger"
  }, "Given date format is invalid. Allowed format are \xA0", allowedFormat.join(', ')));
});
DateInput.displayName = 'DateInput';
DateInput.propTypes = {
  selectedDate: _propTypes.default.object,
  onDateChange: _propTypes.default.func,
  minDate: _propTypes.default.instanceOf(Date),
  maxDate: _propTypes.default.instanceOf(Date),
  dateFormat: _propTypes.default.oneOf(['MM/dd/yyyy', 'MM/yyyy', 'QQQ, yyyy', 'yyyy']),
  // defining allowed formats
  label: _propTypes.default.string,
  onBlur: _propTypes.default.func,
  controlError: _propTypes.default.string,
  UI: _propTypes.default.object,
  icon: _propTypes.default.string,
  iconLocation: _propTypes.default.string
};
DateInput.defaultProps = {
  dateFormat: 'MM/dd/yyyy'
};
var _default = exports.default = DateInput;
//# sourceMappingURL=DateInput.js.map